export default "__VITE_ASSET__pJvCMzlf__"